var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CatalogFiltersBox',{attrs:{"title":_vm.fullTitle,"tooltip":_vm.parameter.cms.description,"init-opened":!_vm.parameter.closedFilter || _vm.parameter.isSelected}},[_c(_vm.parameterWidget.component,{tag:"component",attrs:{"catalog-state":_vm.catalogState,"parameter":_vm.parameter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }